'use strict';

angular.module('documentsManagement')
  .controller('DocumentsListCtrl', [
    '$scope', 'documentsListViewModel', 'masterId', 'documentsApiUrl', 'editPermission',
    function (scope, viewModel, masterId, documentsApiUrl, editPermission) {
      scope.vm = new viewModel(masterId, documentsApiUrl, editPermission);
    }
  ]);